import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const ViewFacilities = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [viewItem, setViewItem] = useState(null);

  useEffect(() => {
    if (location?.state) {
      setViewItem(location.state);
    } else {
      navigate("/facility-master");
    }
  }, [location?.state, navigate]);

  return (
    <div className="container-fluid view-company-sec">
      <section className="company-view-sec">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card mb-2">
              <div className="card-header pl-3">
                <div className="d-flex justify-content-start align-items-center w-100 flex-wrap">
                  <Link to="/facility-master" state={{ companyId: viewItem?.companyId }}>
                    <button className="btn p-0 mr-2" type="button">
                      <i className="fas fa-angle-left"></i>
                    </button>
                  </Link>
                  <h1>Facility Details</h1>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Facility Code</h5>
                      <h6>{viewItem?.facilityCode || "-"}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Facility Name</h5>
                      <h6>{viewItem?.facilityName || "-"}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Country</h5>
                      <h6>{viewItem?.countryName || "-"}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Default</h5>
                      <h6>{viewItem?.isDefault ? "Yes" : "No"}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4">
                    <div>
                      <h5>Address</h5>
                      <h6>{viewItem?.address || "-"}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Status</h5>
                      <h6>{viewItem?.status || "-"}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 mb-4">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="text-right mob-mt-13 mob-mb-15">
              <Link to="/facility-master" state={{ companyId: viewItem?.companyId }}>
                <button className="btn back-btn" type="button">
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewFacilities;
